export default __webpack_public_path__ + "static/media/ic_right-gray.0c101f79.svg";